import { IconButton, Tooltip } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import type { PoolScenario } from '../../types';

interface PrintReportProps {
  scenarios: PoolScenario[];
  currentConfig: PoolScenario;
}

export function PrintReport(_props: PrintReportProps) {
  const handlePrint = () => {
    window.print();
  };

  return (
    <Tooltip title="Print Report">
      <IconButton
        onClick={handlePrint}
        className="no-print"
        size="small"
        color="inherit"
      >
        <PrintIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
